export default __webpack_public_path__ + "static/media/14.573031b8.png";